import React from 'react';
import {
  DatePicker as MuiDatePicker,
  DatePickerProps,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment, { Moment } from 'moment';
import { TextFieldProps } from '@mui/material';
import { DATE_ONLY, DATE_TIME_UTC_FORMAT } from '../../utils/datetime-utils';
import TextField from './TextField';

interface Props extends Omit<DatePickerProps<Moment>, 'value' | 'onChange'> {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
}

const DatePicker = ({
  value,
  onChange,
  placeholder,
  error,
  helperText,
  ...props
}: Props) => {
  const onDateChange = (value: Moment | null) => {
    onChange(value ? value.format(DATE_TIME_UTC_FORMAT) : '');
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MuiDatePicker
        {...props}
        value={value ? moment(value, DATE_TIME_UTC_FORMAT) : undefined}
        timezone="UTC"
        onChange={onDateChange}
        views={['day']}
        format={DATE_ONLY}
        slots={{ textField: TextField as React.FC<TextFieldProps> }}
        slotProps={{
          textField: {
            placeholder,
            error,
            helperText,
          },
          actionBar: { actions: [] },
          day: {
            disableRipple: true,
            sx: {
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: 400,
              lineHeight: '24px',
              '&:hover, :focus': {
                backgroundColor: '#F3F2F0',
                fontWeight: 600,
              },
              '&.Mui-selected': {
                backgroundColor: '#00A399',
                '&:hover, :focus': { backgroundColor: '#00A399' },
              },
              '&.MuiPickersDay-dayOutsideMonth': {
                color: 'inherit',
                opacity: 0.4,
              },
            },
          },
        }}
        dayOfWeekFormatter={(day: string) => day.substring(0, 2)}
        showDaysOutsideCurrentMonth
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
